import type { PropsWithChildren } from 'react'
import { ScrollArea } from '@sunwebgroup/uds-ui/scroll-area'
import cn from 'classnames'
import * as React from 'react'
import { DropdownMultiselectContext } from './context'
import styles from './Options.module.css'

export function Options({ children }: PropsWithChildren) {
  const { asDialog } = React.use(DropdownMultiselectContext)
  return (
    <div className={cn(styles.wrapper, asDialog && styles.wrapperAsDialog)}>
      <ScrollArea.Root>
        <ScrollArea.Viewport>
          {children}
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar orientation="vertical">
          <ScrollArea.Thumb />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </div>
  )
}
